import React from 'react'

function OpenShareDialog(url, title, description, picture_url, successCallback) {
    FB.ui(
        {
            method: 'feed',
            name: title,
            caption: '',
            description: description,
            link: url,
            picture: picture_url
        },
        function (response) {
            if (!(response && response.post_id)) {
                // Cannot publish the post
            } else {
                // Post published
                if (typeof successCallback === 'function') {
                    successCallback();
                }
            }
        }
    );
}

export default class FacebookWallShareButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        event.preventDefault();

        OpenShareDialog(this.props.url,this.props.title, this.props.description, this.props.pictureUrl, this.props.onShareSuccess);
    }

    render() {
        return (
            <div className="facebook-share-button">
                <a href="#" onClick={this.handleClick}>
                    <i className="fa fa-facebook" />
                    <span className="text">{this.props.text}</span>
                </a>
            </div>
        );
    }
}